import { createFileRoute } from "@tanstack/react-router";
import { AssessmentSampleReport } from "@/lib/lazyPages";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";
import { RelatedResources } from "@/components/seo/RelatedResources";

export const Route = createFileRoute("/assessment/sample-report")({
  head: () => seoHead(SEO.assessmentSampleReport),
  component: () => (
    <>
      <AssessmentSampleReport />
      <RelatedResources
        title="Try it with your own child"
        intro="This is an example report. When you are ready, take the full assessment or start with the free, two-minute confidence check."
        items={[
          { href: "/assessment", label: "Take the full personality assessment", note: "Answer about your child and get a report like this one." },
          { href: "/confidence-check-for-kids", label: "See the confidence check", note: "A free, scenario-based check across four confidence areas." },
          { href: "/assessments", label: "Browse the five parent assessments", note: "Communication, empathy, failure, growth mindset and change readiness." },
          { href: "/topics/confidence", label: "Explore confidence resources", note: "Guides, courses and tools on confidence for ages 8-14." },
        ]}
      />
    </>
  ),
});
